import React,{useState,useEffect,useContext} from 'react';
import Header from './Header';
import Prodcard from './Prodcard';
import Filterprodcard from './Filterprodcard';
import axios from 'axios';
import {database} from '../Firebase';
import {AuthContext} from '../Context/AuthContext';
import {Link,useHistory} from 'react-router-dom';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import { toaster } from 'evergreen-ui';


export default function Prodlist() {
  const[items,setItems]=useState([]);
  const{user,Logout}=useContext(AuthContext);
  const history=useHistory();
  

  
  useEffect(()=>{
    async function fetchItems()
    {
      const resp=await axios.get("https://testapp-ef926-default-rtdb.asia-southeast1.firebasedatabase.app/items.json");
      const data=resp.data;
      setItems(data);
    }
    fetchItems();
  },[]);

  



  return (
    <div>
      <Header/>
        <div className="main-body">
          {
            items.map((obj,idx)=>(
              <Prodcard item={obj}/>
            ))
          }
    </div>
    </div>
  )
}
